import {Row, Col} from "antd";
import styled from "styled-components";

export const Container = styled(Row)``;

export const FormHeader = styled(Col)`
    font-size: 20px;
    font-weight: bold;
    width: 100%;
    padding-bottom: 16px;
`;
